/* eslint-disable react-hooks/set-state-in-effect */
// This file uses setState in effect for animation state reset on navigation - intentional pattern
import { useState, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Colors from '@/constants/colors';
import { DetailPageLayoutContext } from './DetailPageLayoutContext';

interface DetailPageLayoutProps {
  children: React.ReactNode;
}

export default function DetailPageLayout({ children }: DetailPageLayoutProps) {
  const location = useLocation();
  const [isExiting, setIsExiting] = useState(false);

  // Reset exit state synchronously when location changes
  // Using useLayoutEffect to run before paint, ensuring animation state is correct
  useLayoutEffect(() => {
    setIsExiting(false);
    window.scrollTo(0, 0);
  }, [location.key]);

  const handleBackNavigation = () => {
    setIsExiting(true);
  };

  // Provide context to DetailPageHeader
  return (
    <DetailPageLayoutContext.Provider value={{ onBack: handleBackNavigation }}>
      <div style={styles.wrapper}>
        <style>{keyframes}</style>
        <div style={{
          ...styles.container,
          animation: isExiting ? 'slideOutToRight 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards' : 'slideInFromRight 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        }}>
          {children}
        </div>
      </div>
    </DetailPageLayoutContext.Provider>
  );
}

const keyframes = `
  @keyframes slideInFromRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOutToRight {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;

const styles = {
  wrapper: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
    backgroundColor: Colors.background,
  } as React.CSSProperties,

  container: {
    width: '100%',
    height: '100%',
    overflow: 'auto' as const,
    animation: 'slideInFromRight 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  } as React.CSSProperties,
};
